/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'megaphone': {
    width: 45,
    height: 45,
    viewBox: '0 0 45 45',
    data: '<g _stroke="#000" stroke-width="2" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M18.303 12.866v26.19c0 .566-.283 1.095-.754 1.41l-2.327 1.55a1.693 1.693 0 01-2.582-.998L9.836 29.801"/><path pid="1" d="M9.836 29.801a8.467 8.467 0 010-16.935h8.467s11.527 0 22.619-9.303a1.693 1.693 0 012.783 1.295V37.81a1.693 1.693 0 01-2.783 1.294c-11.092-9.303-22.619-9.303-22.619-9.303H9.836z"/></g>'
  }
})
